<template>
  <v-app-bar app>
    <v-app-bar-nav-icon @click="$emit('toggleMenu')"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ $router.currentRoute.name }}</v-toolbar-title>
    <v-spacer></v-spacer>
    v0.5.0
  </v-app-bar>
</template>

<script>
export default {
  props: {},
  name: 'default-app-bar',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
